import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-numeric-slider-config',
  templateUrl: './numeric-slider-config.component.html',
  styleUrls: ['./numeric-slider-config.component.scss'],
})
export class NumericSliderConfigComponent implements OnInit {

  @Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
